import "@fontsource-variable/archivo/wdth.css";
import "@fontsource/instrument-serif/400-italic.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./styles.css";
import "./themes.css";

import { Amplify } from "aws-amplify";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { setApiBase } from "./lib/api";
import { loadConfig } from "./lib/config";
import { applyTheme, storedTheme } from "./lib/theme";

// The chosen look goes on <html> before anything renders, so pages never flash the default.
applyTheme(storedTheme(), false);

const root = createRoot(document.getElementById("root")!);

loadConfig()
  .then((config) => {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: config.userPoolId,
          userPoolClientId: config.userPoolClientId,
          loginWith: { email: true },
        },
      },
    });
    setApiBase(config.apiBase);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((err: Error) => {
    root.render(
      <main className="page">
        <p className="notice" role="alert">
          {err.message}
        </p>
      </main>,
    );
  });
